import axios from "../config/axios"

const API_BASE = "/ml-sheets"

export const mlSheetService = {
  // Get all ML Sheets with filters and pagination
  getAllMLSheets: (page = 1, perPage = 10, filters = {}) => {
    const params = {
      page,
      per_page: perPage,
      ...filters,
    }
    return axios.get(API_BASE, { params })
  },

  // Get single ML Sheet
  getMLSheet: (mlSheetId, params = {}) => {
    return axios.get(`${API_BASE}/${mlSheetId}`, { params })
  },

  getMLSheetViewRows: (mlSheetId) => {
    return axios.get(`${API_BASE}/${encodeURIComponent(mlSheetId)}/view-rows`)
  },

  getPickupAddableShipments: (mlSheetId) => {
    return axios.get(`${API_BASE}/${encodeURIComponent(mlSheetId)}/pickup-shipments`)
  },

  addPickupShipments: (mlSheetId, shipmentIds) => {
    return axios.post(`${API_BASE}/${encodeURIComponent(mlSheetId)}/pickup-shipments`, {
      shipment_ids: shipmentIds,
    })
  },

  // Shipments from ML sheets assigned to current user (standalone Update Status page)
  getAgentStatusShipments: (searchOrOptions = "", options = {}) => {
    const opts = typeof searchOrOptions === "object" && searchOrOptions !== null
      ? searchOrOptions
      : { search: searchOrOptions, ...options }
    const params = {
      page: opts.page || 1,
      per_page: opts.perPage || opts.per_page || 30,
    }
    const search = (opts.search || "").trim()
    if (search) params.search = search
    const statuses = opts.statuses || opts.status
    if (Array.isArray(statuses) && statuses.length) {
      params.status = statuses.join(",")
    } else if (typeof statuses === "string" && statuses.trim()) {
      params.status = statuses.trim()
    }
    if (opts.missing) params.missing = 1
    return axios.get(`${API_BASE}/agent-status-shipments`, { params })
  },

  // Create ML Sheet
  createMLSheet: (data) => {
    return axios.post(API_BASE, data)
  },

  ensureShipmentCommission: (mlSheetId) => {
    return axios.post(`${API_BASE}/${encodeURIComponent(mlSheetId)}/ensure-shipment-commission`)
  },

  // Update ML Sheet
  updateMLSheet: (mlSheetId, data) => {
    return axios.put(`${API_BASE}/${mlSheetId}`, data)
  },

  // Delete ML Sheet
  deleteMLSheet: (mlSheetId) => {
    return axios.delete(`${API_BASE}/${mlSheetId}`)
  },

  // Get booked shipments by location and date - NEW DYNAMIC SEARCH
  getBookedShipments: (params = {}) => {
    return axios.get(`${API_BASE}/booked-shipments`, { params })
  },

  // Generate PDF
  generatePDF: (mlSheetId, paymentMode = null) => {
    const params = {}
    if (paymentMode && paymentMode !== "all") {
      params.payment_mode = paymentMode
    }
    return axios.get(`${API_BASE}/${mlSheetId}/pdf`, {
      responseType: "blob",
      params,
    })
  },

  // Download PDF
  downloadPDF: (mlSheetId) => {
    return axios.get(`${API_BASE}/${mlSheetId}/pdf/download`, {
      responseType: "blob",
    })
  },

  ewayBillSheet: (mlSheetId) => {
    return axios.get(`${API_BASE}/${mlSheetId}/eway-bill-sheet`, {
      responseType: "blob",
    })
  },

  // Company agents eligible for ML access (own + contracted + partners).
  // Do not use /users — Agents are scoped to only themselves there.
  getAgents: () => {
    return axios.get(`${API_BASE}/access-agents`)
  },

  // Get shipment by ID
  getShipmentById: (shipmentId) => {
    return axios.get(`/shipments/${shipmentId}`)
  },

  // Get all locations
  getLocations: () => {
    return axios.get("/location-hubs", { params: { all: true } })
  },

  // Get all vehicles without pagination
  getAllVehiclesNoPage: () => {
    return axios.get("/vehicles", { params: { all: true } })
  },

  // Scan ML Sheet from image (QR code or shipment image)
  scanMLSheetImage: (formData) => {
    return axios.post(`${API_BASE}/scan-image`, formData, {
      headers: {
        "Content-Type": undefined,
      },
    })
  },

  /** Resolve shipment(s) from app live QR decode — no image upload. */
  resolveQrScan: ({ qrData, qrCodes, shipmentIds } = {}) => {
    const payload = {}
    if (qrData) payload.qr_data = qrData
    if (qrCodes?.length) payload.qr_codes = qrCodes
    if (shipmentIds?.length) payload.shipment_ids = shipmentIds
    return axios.post(`${API_BASE}/scan-image`, payload)
  },

  // Create ML Sheet from scanned data
  createMLSheetFromScan: (data) => {
    return axios.post(`${API_BASE}/from-scan`, data)
  },

  getForSelection: (params = {}) => {
    return axios.get(`${API_BASE}/for-selection`, {
      params: { status: "OPEN", appendable_only: true, ...params },
    })
  },

  /** Same-day remaining capacity for a vehicle (cargo). */
  getVehicleDayCapacity: ({ vehicleId, date, excludeMlSheetId } = {}) => {
    const params = { vehicle_id: vehicleId }
    if (date) params.date = date
    if (excludeMlSheetId) params.exclude_ml_sheet_id = excludeMlSheetId
    return axios.get(`${API_BASE}/vehicle-day-capacity`, { params })
  },
}
